import React from "react";
import { Box, Grid, Typography, Table, TableHead, TableRow, TableCell, TableBody, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";

const defaultSections = [
  {
    title: "Н/ч",
    data: [
      { label: "—", value: "—" },
      { label: "—", value: "—" },
    ],
  },
  {
    title: "Эффективность",
    data: [
      { label: "—", value: "—" },
      { label: "—", value: "—" },
    ],
  },
  {
    title: "Количество авто",
    data: [
      { label: "—", value: "—" },
      { label: "—", value: "—" },
    ],
  },
];

const HistoryEffectiveness = ({ sections = [] }) => {
  const classes = useStyles();
  const isDesktop = useMediaQuery("(min-width:859px)");
  const viewSections = sections.length ? sections : defaultSections;

  if (isDesktop) {
    const monthLabel = viewSections?.[0]?.data?.[0]?.label || "Текущий месяц";
    const yearLabel = viewSections?.[0]?.data?.[1]?.label || "Текущий год";
    return (
      <Table className={classes.tableDesktop}>
        <TableHead>
          <TableRow>
            {viewSections.map((section) => (
              <TableCell key={section.title} colSpan={2}>{section.title}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow className={classes.tableRowTitle}>
            {viewSections.map((section) => (
              <React.Fragment key={`${ section.title }-labels`}>
                <TableCell>{section?.data?.[0]?.label || monthLabel}</TableCell>
                <TableCell>{section?.data?.[1]?.label || yearLabel}</TableCell>
              </React.Fragment>
            ))}
          </TableRow>
          <TableRow className={classes.tableRowValue}>
            {viewSections.map((section) => (
              <React.Fragment key={`${ section.title }-values`}>
                <TableCell>{section?.data?.[0]?.value || "—"}</TableCell>
                <TableCell>{section?.data?.[1]?.value || "—"}</TableCell>
              </React.Fragment>
            ))}
          </TableRow>
        </TableBody>
      </Table>
    );
  }
  return (
    <Box className={classes.rootMobile}>
      {viewSections.map((section, idx) => (
        <React.Fragment key={section.title}>
          <Box className={classes.sectionHeader}>
            <Typography className={classes.sectionTitle}>{section.title}</Typography>
          </Box>

          <Grid container spacing={2} className={classes.row}>
            {section.data.map((item) => (
              <Grid key={item.label} item xs={6}>
                <Typography className={classes.label}>{item.label}</Typography>
                <Typography className={classes.value}>{item.value}</Typography>
              </Grid>
            ))}
          </Grid>

          {idx !== sections.length - 1 && <div className={classes.divider} />}
        </React.Fragment>
      ))}
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  tableDesktop: {
    width: "auto",
    "& .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root": {
      padding: "0 20px!important",
      paddingBottom: "10px!important",
      border: "none",
      borderBottom: "1px solid #F3F3F3",

      fontSize: "12px!important",
      fontWeight: "400!important",

      "&:first-child": {
        paddingLeft: "0!important",
      }
    },
    "& .MuiTableCell-root": {
      borderBottom: "none",
      fontSize: 14,
      color: "#434146",
      paddingTop: 12,
      paddingBottom: 12,
    },
  },
  tableRowTitle: {
    "& .MuiTableCell-root": {
      minWidth: "100px",
      boxSizing: "border-box",
      padding: "0 20px!important",
      paddingTop: "20px!important",
      borderLeft: "none!important",
      borderRight: "none!important",

      "&:first-child": {
        paddingLeft: "0!important",
      },
      "&:nth-of-type(3), &:nth-of-type(5)": {
        borderLeft: "1px solid #F3F3F3!important"
      }
    }
  },
  tableRowValue: {
    "& .MuiTableCell-root": {
      padding: "0 20px!important",
      paddingTop: "2px!important",
      paddingBottom: "20px!important",
      borderLeft: "none!important",
      borderRight: "none!important",
      borderBottom: "1px solid #F3F3F3!important",

      color: "#FF3C43!important",
      fontSize: "16px!important",
      fontWeight: "700!important",

      "&:first-child": {
        paddingLeft: "0!important",
      },
      "&:nth-of-type(3), &:nth-of-type(5)": {
        borderLeft: "1px solid #F3F3F3!important"
      },
    },
  },
  rootMobile: {
    background: "#F5F5F5",
    borderRadius: 12,
    padding: "16px 16px 12px",
    boxSizing: "border-box",
  },
  title: {
    fontSize: 16,
    fontWeight: 700,
    color: "#434146",
    lineHeight: "18px",
    marginBottom: 12,
  },
  sectionHeader: {
    marginBottom: 8,
  },
  sectionTitle: {
    fontSize: 13,
    fontWeight: 600,
    color: "#434146",
    lineHeight: "16px",
  },
  row: {
    marginBottom: 8,
  },
  label: {
    fontSize: 13,
    fontWeight: 400,
    color: "#808083",
    lineHeight: "16px",
    marginBottom: 4,
  },
  value: {
    fontSize: 16,
    fontWeight: 700,
    color: "#FF3C43",
    lineHeight: "18px",
  },
  divider: {
    height: 1,
    background: "#EAEAEA",
    margin: "10px -16px 12px",
  },
}));

export default HistoryEffectiveness;
